module.exports = __webpack_public_path__ + "media/images/matte-9e0bfdb8ceb643cc21bfde3fc836561a.png";